;(function( global ) {
	var
		Konnekt = global.Konnekt = global.Konnekt || {};
		Integration = Konnekt.Integration = Konnekt.Integration || {};

	Konnekt.Channel = require( "util/channel" );

	Integration.CookieConsent   = require( "konnekt/outsystems/cookie-consent" );
	Integration.Frame           = require( "konnekt/outsystems/frame-tools" );

	Integration.ResizeBroadcast = function( selector ) {
		Integration.Frame.resizeOn( selector );

		if ( "console" in window && "warn" in console ) {
			console.warn([
				"`Konnekt.Integration.ResizeBroadcast(selector:String)` is deprecated.",
				"Use `Konnekt.Integration.Frame.resizeOn(element:String|Element|jQuery)` instead."
			].join("\n"));
		}
	}

}( this ));
